@if (visible()) {
  <div
    class="patient-alerts-date-indicator-badge inline-flex items-center gap-1 rounded-md bg-background-light-grey p-1"
    [libUiTooltip]="tooltipTpl"
    tooltipPosition="bottom"
  >
    <span class="typo-h7-light text-text-secondary">{{ badgeLabelKey() | translate }}</span>
    @if (badgeDate()) {
      <span class="typo-h7-light text-text-tertiary">{{ badgeDate() }}</span>
    }
  </div>
}

<ng-template #tooltipTpl>
  <div class="flex w-[216px] flex-col gap-2 px-0 py-1">
    <div class="flex w-full items-end justify-between gap-4">
      <span class="typo-h7-extralight text-text-tertiary">{{ 'patient_alerts_tooltip_created' | translate }}</span>
      <span class="typo-h7-light text-text-secondary">{{ createdDate() }}</span>
    </div>

    @if (showStartsRow()) {
      <div class="flex w-full items-end justify-between gap-4">
        <span class="typo-h7-extralight text-text-tertiary">{{ 'patient_alerts_tooltip_starts' | translate }}</span>
        <span class="typo-h7-light text-text-secondary">{{ startsDate() }}</span>
      </div>
    }
    @if (showStartedRow()) {
      <div class="flex w-full items-end justify-between gap-4">
        <span class="typo-h7-extralight text-text-tertiary">{{ 'patient_alerts_tooltip_started' | translate }}</span>
        <span class="typo-h7-light text-text-secondary">{{ startedDate() }}</span>
      </div>
    }
    @if (showEndsRow()) {
      <div class="flex w-full items-end justify-between gap-4">
        <span class="typo-h7-extralight text-text-tertiary">{{ 'patient_alerts_tooltip_ends' | translate }}</span>
        <span class="typo-h7-light text-text-secondary">{{ endsDate() }}</span>
      </div>
    }
    @if (showEndedRow()) {
      <div class="flex w-full items-end justify-between gap-4">
        <span class="typo-h7-extralight text-text-tertiary">{{ 'patient_alerts_tooltip_ended' | translate }}</span>
        <span class="typo-h7-light text-text-secondary">{{ endedDate() }}</span>
      </div>
    }
    @if (showShowInRow()) {
      <div class="flex w-full items-end justify-between gap-4">
        <span class="typo-h7-extralight text-text-tertiary">{{ 'health_history_patient_alerts_tab_show_in' | translate }}</span>
        <span class="typo-h7-light text-text-secondary"
          >@for (key of showInList(); track key; let last = $last) {{{ key | translate }}{{ last ? '' : ', ' }}}</span
        >
      </div>
    }
    @if (showPermanentRow()) {
      <div class="flex w-full">
        <span class="typo-h7-extralight text-text-tertiary">{{ 'patient_alerts_tooltip_permanent' | translate }}</span>
      </div>
    }
  </div>
</ng-template>
